import { ComponentEvents } from '../../../../global/interfaces/component.interface';

const EVENT_PREFIX = 'MoleculeProductGalleryEvents__';


/** The type of custom events emitted */
export type MoleculeProductGalleryEventTypes = {
	thumbnailChanged: number;
};

/** The event names for the above events */
export const MoleculeProductGalleryEvents: ComponentEvents<MoleculeProductGalleryEventTypes> = {
	/** Event emitted when a thumbnail is selected */
	thumbnailChanged: EVENT_PREFIX + 'ThumbnailChanged',
};
